export default "__VITE_ASSET__B0P44w8B__"